import React, { useEffect, useState, useCallback } from "react";
import { connect } from "react-redux";

import {
  configuracionEvento,
  resultadosEventoNew,
  detalleEvento,
  getPuntosControl,
  eventSubEvents,
} from "../../../data-store/actions/events-actions";

import ResultsReportNew from "../reports/ResultsReportNew";
import BuscadorResults from "../reports/BuscadorResults";
import { formatEventDate } from "../../../services/utils";

import AppContainer from "../../../AppContainer";

import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import LinearProgress from "@material-ui/core/LinearProgress";

import {
  Paper,
  Grid,
  Button,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
} from "@material-ui/core";

import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";
import { makeStyles } from "@material-ui/core/styles";
import ResultadosPorTeam from "../reports/ResultadosPorTeam";

const useStyles = makeStyles((theme) => ({
  actionsRoot: {
    padding: 12,
  },
  searchBtn: {
    width: "100%",
    minHeight: 52,
    borderRadius: 16,
    textTransform: "none",
    fontWeight: 900,
    letterSpacing: 0,
    lineHeight: 1.15,
    boxShadow: "0 2px 10px rgba(0,0,0,0.12)",
    justifyContent: "space-between",
    paddingLeft: 14,
    paddingRight: 14,
  },
  dialogPaper: {
    borderRadius: 14,
  },
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    fontWeight: 800,
    flex: "1 1 auto",
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  dialogBody: {
    padding: theme.spacing(1.5),
  },
}));

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error,
    };
  }

  componentDidCatch(error, info) {
    console.error("Error en PastEventShowView:", error);
    console.error("Info del error:", info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <AppContainer>
          <Container maxWidth="sm">
            <Paper style={{ padding: 20, marginTop: 20 }}>
              <Typography variant="h6" color="error" gutterBottom>
                Ocurrió un error mostrando este evento
              </Typography>

              <Typography variant="body2" component="pre" style={{ whiteSpace: "pre-wrap" }}>
                {String(this.state.error)}
              </Typography>

              <Button
                variant="contained"
                color="primary"
                onClick={() => window.location.reload()}
                style={{ marginTop: 16 }}
              >
                Recargar página
              </Button>
            </Paper>
          </Container>
        </AppContainer>
      );
    }

    return this.props.children;
  }
}

function PastEventShowView(props) {
  const classes = useStyles();

  const [controles] = useState(false);

  const [resultsOpen, setResultsOpen] = useState(false);
  const [resultsTitle, setResultsTitle] = useState("");
  const [reportType, setReportType] = useState(null);

  const [searchOpen, setSearchOpen] = useState(false);

  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 600 : false
  );

  const eventoIndex = props.match?.params?.EventoIndex;

  useEffect(() => {
    if (!eventoIndex) {
      console.error("No existe EventoIndex en params");
      return;
    }

    props.detalleEvento(eventoIndex);
    props.resultadosEventoNew(eventoIndex);
    props.eventSubEvents(eventoIndex);
    props.configuracionEvento(eventoIndex);
    props.getPuntosControl(eventoIndex);
  }, [eventoIndex]);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 600);

    window.addEventListener("resize", onResize);

    return () => window.removeEventListener("resize", onResize);
  }, []);

  const message_1 =
    props.eventConfiguration?.timingConfig?.messages?.message_1 || false;

  const openReport = useCallback((type, title) => {
    setReportType(type);
    setResultsTitle(title);
    setResultsOpen(true);
  }, []);

  const closeResults = useCallback(() => {
    setResultsOpen(false);
  }, []);

  const closeSearch = useCallback(() => {
    setSearchOpen(false);
  }, []);

  const openSearchFromMain = useCallback(() => {
    setSearchOpen(true);
  }, []);

  const openSearchFromResults = useCallback(() => {
    setSearchOpen(true);
  }, []);

  if (!props.eventDetail) {
    return (
      <AppContainer>
        <LinearProgress />
      </AppContainer>
    );
  }

  const nombreEvento = props.eventDetail.nombreEvento || "Evento sin nombre";
  const logoEvento = props.eventDetail.logoEvento || "";
  const horaEvento = props.eventDetail.horaEvento || "";
  const lugarEvento = props.eventDetail.lugarEvento || "";
  const ciudadEvento = props.eventDetail.ciudadEvento || "";
  const paisEvento = props.eventDetail.paisEvento || "";

  let fechaEventoTexto = "fecha no disponible";

  try {
    fechaEventoTexto = props.eventDetail.fechaEvento
      ? formatEventDate(props.eventDetail.fechaEvento)
      : "fecha no disponible";
  } catch (error) {
    console.error("Error formateando fechaEvento:", props.eventDetail.fechaEvento, error);
  }

  return (
    <AppContainer>
      <Container maxWidth="sm">
        <Card>
          {logoEvento ? (
            <CardMedia
              component="img"
              alt={"Logo evento: " + nombreEvento}
              height="auto"
              image={logoEvento}
              title={"Logo evento: " + nombreEvento}
            />
          ) : null}

          <CardContent>
            <Typography gutterBottom variant="h5" component="h2">
              {nombreEvento}
            </Typography>

            <Typography variant="body2" color="textSecondary" component="div">
              <p>
                Evento Realizado el {fechaEventoTexto}
                {horaEvento ? `, a las ${horaEvento}` : ""}
              </p>

              <p>
                en {lugarEvento}
                {ciudadEvento ? `, ${ciudadEvento}` : ""}
                {paisEvento ? `, ${paisEvento}` : ""}
              </p>
            </Typography>
          </CardContent>

          <CardActions className={classes.actionsRoot}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={openSearchFromMain}
                  fullWidth
                  className={classes.searchBtn}
                  startIcon={<SearchIcon />}
                >
                  Buscar por nombre ó Número
                </Button>
              </Grid>

              <Grid item xs={6}>
                <Button
                  color="primary"
                  onClick={() => openReport(1, "Resultados Generales")}
                  fullWidth
                >
                  Resultados Generales
                </Button>
              </Grid>

              <Grid item xs={6}>
                <Button
                  color="primary"
                  onClick={() => openReport(2, "Resultados por Género")}
                  fullWidth
                >
                  Resultados Género
                </Button>
              </Grid>

              <Grid item xs={6}>
                <Button
                  color="primary"
                  onClick={() => openReport(3, "Resultados por Categoría")}
                  fullWidth
                >
                  Resultados Categoría
                </Button>
              </Grid>

              <Grid item xs={6}>
                <Button
                  color="primary"
                  onClick={() => openReport(4, "Resultados Ganadores")}
                  fullWidth
                >
                  Resultados Ganadores
                </Button>
              </Grid>
              <Grid item xs={12}>
                {props.eventResults &&
                  props.eventConfiguration &&
                  props.eventConfiguration.timingConfig &&
                  props.eventConfiguration.timingConfig.teams &&
                  props.eventConfiguration.timingConfig.teams.showTeams &&

                  <Button
                    color="primary"
                    onClick={() => openReport(5, "Resultados por Equipo")}
                    fullWidth
                  >
                    Resultados por Equipo
                  </Button>
                }
              </Grid>
            </Grid>
          </CardActions>

          {message_1 && (
            <Paper style={{ margin: 20, padding: 10, backgroundColor: "#e0e0e0" }}>
              <Typography
                style={{ margin: 20, textAlign: "center" }}
                variant="h5"
                component="p"
              >
                {message_1}
              </Typography>
            </Paper>
          )}
        </Card>
      </Container>

      <Dialog
        open={resultsOpen}
        onClose={closeResults}
        fullScreen
        fullWidth
        maxWidth="md"
        classes={{ paper: classes.dialogPaper }}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={closeResults}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>

            <Typography variant="h6" className={classes.title}>
              {resultsTitle}
            </Typography>

            <IconButton
              edge="end"
              color="inherit"
              aria-label="search"
              onClick={openSearchFromResults}
            >
              <SearchIcon />
            </IconButton>
          </Toolbar>
        </AppBar>

        <div className={classes.dialogBody}>
          {reportType === 5 ? (
            <ResultadosPorTeam
              resultados={props.eventResults || {}}
              cantidadAtletasPorEquipo={3}
              mostrarAtletas={true}
              mostrarMilisegundos={true}
              titulo="Resultados por equipo"
            />
          ) : reportType ? (
            <ResultsReportNew
              reportResultType={reportType}
              controles={controles}
              eventDetail={props.eventDetail}
              puntosControl={props.puntosControl || {}}
            />
          ) : null}
        </div>
      </Dialog>

      <Dialog
        open={searchOpen}
        onClose={closeSearch}
        fullScreen={isMobile}
        fullWidth
        maxWidth="sm"
        classes={{ paper: classes.dialogPaper }}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={closeSearch}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>

            <Typography variant="h6" className={classes.title}>
              Buscar por nombre ó número
            </Typography>
          </Toolbar>
        </AppBar>

        <div className={classes.dialogBody}>
          <BuscadorResults icon={false} />
        </div>
      </Dialog>
    </AppContainer>
  );
}

const mapStateToProps = (state, { match }) => {
  const EventoIndex = match?.params?.EventoIndex;
  const eventsState = state.events || {};

  return {
    evento: eventsState.events ? eventsState.events[EventoIndex] : undefined,
    eventDetail: eventsState.eventDetail,
    eventResults: eventsState.eventResults,
    eventSubEvents: eventsState.eventSubEvents,
    eventConfiguration: eventsState.eventConfiguration,
    puntosControl: eventsState.puntosControl,
  };
};

const mapDispatchToProps = {
  detalleEvento,
  resultadosEventoNew,
  eventSubEvents,
  configuracionEvento,
  getPuntosControl,
};

const ConnectedPastEventShowView = connect(
  mapStateToProps,
  mapDispatchToProps
)(PastEventShowView);

export default function PastEventShowViewWithBoundary(props) {
  return (
    <ErrorBoundary>
      <ConnectedPastEventShowView {...props} />
    </ErrorBoundary>
  );
}